export default {
    api_title: 'API Key Management',
    api_key: 'API Key',
};
